(() => {
  async function refreshDrawer() {
    const r = await fetch(location.pathname + '?sections=cart-drawer-section');
    const d = await r.json();
    const html = d['cart-drawer-section'];
    const holder = document.getElementById('shopify-section-cart-drawer-section');
    if (html && holder) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById('shopify-section-cart-drawer-section') || doc.body.firstElementChild;
      if (fresh) holder.innerHTML = fresh.innerHTML;
    }
    const dr = document.getElementById('cart-drawer');
    if (dr && typeof dr.open === 'function' && !dr.hasAttribute('open')) dr.open();
  }
  window.hRefreshDrawer = refreshDrawer;
  document.addEventListener('change', async (e) => {
    const cb = e.target.closest('[data-h-ins]');
    if (!cb) return;
    cb.disabled = true;
    const id = cb.dataset.hIns;
    try {
      if (cb.checked) {
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) });
      } else {
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(id), quantity: 0 }) });
      }
      await refreshDrawer();
    } catch (err) { cb.checked = !cb.checked; }
    cb.disabled = false;
  });
})();

// cart reservation timer (10 min per browser session, restarts when it runs out)
(() => {
  if (window.__hReserve) return; window.__hReserve = 1;
  const KEY = 'h_res_end'; const get = () => { try { return +sessionStorage.getItem(KEY) || 0; } catch (e) { return 0; } };
  const set = (v) => { try { sessionStorage.setItem(KEY, v); } catch (e) {} };
  setInterval(() => {
    const els = document.querySelectorAll('[data-h-reserve]'); if (!els.length) return;
    let end = get(); if (!end || end < Date.now()) { end = Date.now() + 600000; set(end); }
    const s = Math.max(0, Math.floor((end - Date.now()) / 1000));
    const t = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
    els.forEach((e) => { e.textContent = t; });
  }, 1000);
})();

// cart upsell "Complete your routine"
document.addEventListener('click', async (e) => {
  const b = e.target.closest('[data-h-up]'); if (!b) return;
  b.disabled = true; b.textContent = 'Adding…';
  try { await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.hUp, quantity: 1 }] }) });
    if (window.hRefreshDrawer) await window.hRefreshDrawer(); } catch (err) {}
});

// cart sanity: gifts / guide / insured shipping can only stay with the ampoule in the cart
(() => {
  if (window.__hSanity) return; window.__hSanity = 1;
  const MAIN = 'deep-collagen-peptide-ampoule', GIFT = 'mystery-gift', GUIDE = 'k-beauty-glow-guide', INS = 'premium-insured-shipping', FOUR = 67706771112258;
  let busy = false;
  async function sanity() {
    if (busy) return; busy = true;
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const main = cart.items.filter((i) => i.handle === MAIN);
      const hasFour = main.some((i) => i.variant_id === FOUR);
      const updates = {};
      cart.items.forEach((i) => {
        if (!main.length && (i.handle === GIFT || i.handle === GUIDE || i.handle === INS)) updates[i.key] = 0;
        else if (i.handle === GUIDE && !hasFour) updates[i.key] = 0;
        else if ((i.handle === GIFT || i.handle === GUIDE) && i.quantity > 1) updates[i.key] = 1;
      });
      if (Object.keys(updates).length) {
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
        if (window.hRefreshDrawer) await window.hRefreshDrawer();
      }
    } catch (e) {}
    busy = false;
  }
  window.hCartSanity = sanity;
  const later = () => setTimeout(sanity, 1400);
  document.addEventListener('click', (e) => { if (e.target.closest('.cart-items__remove, quantity-selector-component button, .quantity-minus, .quantity-plus, [name="minus"], [name="plus"]')) later(); });
  document.addEventListener('change', (e) => { if (e.target.closest('quantity-selector-component, .cart-items__quantity')) later(); });
  ['cart:update', 'cart:updated'].forEach((ev) => document.addEventListener(ev, later));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sanity); else sanity();
})();

// fast remove: one /cart/update.js call removes the line + anything that depends on it, then one redraw
(() => {
  if (window.__hFastRm) return; window.__hFastRm = 1;
  const MAIN = 'deep-collagen-peptide-ampoule', GIFT = 'mystery-gift', GUIDE = 'k-beauty-glow-guide', INS = 'premium-insured-shipping', FOUR = 67706771112258;
  let cartP = null;
  const prefetch = () => { cartP = fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).catch(() => null); };
  window.addEventListener('pointerdown', (e) => { if (e.target.closest('.cart-items__remove, [data-h-rm]')) prefetch(); }, true);
  window.addEventListener('click', async (e) => {
    const b = e.target.closest('.cart-items__remove, [data-h-rm]'); if (!b) return;
    const row = b.closest('tr[data-key]'); if (!row) return;
    e.preventDefault(); e.stopImmediatePropagation();
    const key = row.dataset.key;
    row.classList.add('h-removing');
    try {
      const cart = (await (cartP || (prefetch(), cartP))) || { items: [] }; cartP = null;
      const updates = { [key]: 0 };
      const left = cart.items.filter((i) => i.key !== key);
      const main = left.filter((i) => i.handle === MAIN);
      const four = main.some((i) => i.variant_id === FOUR);
      left.forEach((i) => {
        if (!main.length && [GIFT, GUIDE, INS].includes(i.handle)) updates[i.key] = 0;
        else if (i.handle === GUIDE && !four) updates[i.key] = 0;
      });
      const res = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates, sections: 'cart-drawer-section' }) }).then((r) => r.json());
      const html = res.sections && res.sections['cart-drawer-section'];
      const holder = document.getElementById('shopify-section-cart-drawer-section');
      if (html && holder) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.getElementById('shopify-section-cart-drawer-section') || doc.body.firstElementChild;
        if (fresh) holder.innerHTML = fresh.innerHTML;
      } else if (window.hRefreshDrawer) await window.hRefreshDrawer();
      document.querySelectorAll('.cart-bubble__text-count').forEach((el) => { el.textContent = res.item_count; });
      document.querySelectorAll('.cart-bubble').forEach((el) => el.classList.toggle('visually-hidden', !res.item_count));
    } catch (err) { row.classList.remove('h-removing'); }
  }, true);
})();
